import { accreditationsService } from 'hq/services';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import {
  AccreditationType,
  RawAccreditationData,
} from '../../../../services/accreditations-service.types';

const useGetAccreditationDetail = (
  certificateId: string,
  flexWorkerId: string,
  accreditationType: AccreditationType
) => {
  const queryFn = async () =>
    await accreditationsService.getAccreditationDetail(
      certificateId,
      flexWorkerId,
      accreditationType
    );

  return useQuery<RawAccreditationData, Error>(QUERY_KEYS.accreditationDetail(), queryFn);
};

export { useGetAccreditationDetail };
